import ModalCheckPasscode, { globalModalCheckPasscodeRef } from 'modules/shop/widgets/ModalCheckPassCode';
import { Navigate, Outlet } from 'react-router-dom';
import storage from 'utils/sessionStorage';

const PrivateLayout = () => {
  const token = storage.token.get();
  if (!token) return <Navigate to={'/login'} replace />;
  return <>
    <Outlet />
    <ModalCheckPasscode ref={globalModalCheckPasscodeRef} />
  </>
    ;
};

export default PrivateLayout;
